import { useAppState } from './useAppState.js';
export var useWallets = function useWallets() {
  return useAppState('wallets');
};